module.exports = __webpack_public_path__ + "img/notRelevant.d49f7f37.svg";